import { ContentPage } from '@malesia/react-components/dist/src/components/ContentPage/ContentPage';
import { HtmlBlock } from '@malesia/react-components/dist/src/components/Front/HtmlBlock/HtmlBlock';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { useIntl } from 'react-intl';
import useSWR from 'swr';
import { loadImprintPageContent } from '../../services/directus/imprintPage/loadImprintPageContent';

export const MalesiaImprintPage: SFC = () => {
    const { locale } = useIntl();
    const { data } = useSWR([locale, 'loadImprintPageContent'], loadImprintPageContent);

    return (
        <>
            <ContentPage
                image={data?.topImage}
            >
                <HtmlBlock content={data?.content ?? ''} />
            </ContentPage>
        </>
    );
};
